import React from 'react';
import { Root } from './style';

import { useSiteData } from 'utils';

import ContractLinks from 'components/Common/ContractLinks';
import RawHTML from 'components/Common/RawHTML';

import mobiles from 'assets/Common/ReadyToStart/mobiles.png';
import vars from 'variables';

const ReadyToStart = () => {
  const {
    banners: { readyToStart },
  } = useSiteData().resources;

  return (
    <Root className="ready-to-start body-width">
      <div className="content">
        <RawHTML html={readyToStart} />
        <a
          className="button transparent logo"
          href={vars.links.buy}
          target="_blank"
          rel="noreferrer"
        >
          Buy HODL Now
        </a>
        <ContractLinks />
        <div className="lines" />
      </div>
      <img src={mobiles} />
    </Root>
  );
};

export default ReadyToStart;
